<template>
   <v-card class="px-6 pt-8 pb-4" outlined>
    <v-text-field
      outlined
      label="Title"
      readonly
      :value="promo.header">
    </v-text-field>

    <v-text-field
      outlined
      label="Sub Title"
      readonly
      :value="promo.sub_header">
    </v-text-field>

    <v-text-field
      outlined
      label="Signup URL"
      readonly
      :value="promo.affiliate_link">
    </v-text-field>

    <v-checkbox
      class="mt-0"
      label="Best Promo"
      readonly
      v-model="promo.best_promo_flag"
    ></v-checkbox>

    <v-checkbox
      class="mt-0"
      label="Welcome Promo"
      readonly
      v-model="promo.welcome_promo_flag"
    ></v-checkbox>

    <v-card-actions >
      <v-btn text class="text-transform-none" @click="$emit('remove', promo)">Remove</v-btn>
      <v-spacer></v-spacer>
      <v-btn text class="text-transform-none" color="primary" @click="show = true">Modify</v-btn>
    </v-card-actions>
    <promo-modal-form v-if="show" v-model="show" :promo="promo" title="Promo" successText="Update" @success="$emit('change', $event)"/>
  </v-card>
</template>
<script>
import PromoModalForm from '../components/PromoModalForm'
export default {
  props: {
    promo: {
      type: Object,
      required: true
    }
  },
  components: {
    PromoModalForm
  },
  data () {
    return {
      show: false
    }
  }
}
</script>
